<div [ngClass]="Theme">
    <div class="boton" [ngClass]="{'visibility_hidden': Loading_sk}">
        <div class="wrapper">

            <div class="label">
                <!-- <p *ngIf="Theme != 'boton-thumb-descarga'">{{Label}}</p> -->
                <div [innerHTML]="Label"></div>
                <!-- <div class="puntos" *ngIf="Theme === 'boton-enviar' || Theme === 'boton-solicitar-desafiliarme' ">
          <span #p1>.</span>
          <span #p2>.</span>
          <span #p3>.</span>
        </div> -->

            </div>

            <div class="ico-svg" *ngIf="IcoSvg != null">                
                <app-icon [Path]="IcoSvg"></app-icon>
            </div>

        </div>
    </div>
    <!-- <ng-container *ngIf=" Loading_sk">
        <app-skeletoons loading Theme="skeletoons-primary"></app-skeletoons>
    </ng-container> -->
</div>